export default __webpack_public_path__ + "static/media/bg_visa_02.fa01b419.jpg";